"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var React = _interopRequireWildcard(require("react"));
require("../../../src/ui/dropdown/dropdown.module.scss");
var _excluded = ["children", "className", "directionVertical", "directionHorizontal", "isFitWindow", "isScaleAnimation", "opened", "portal", "style", "onAnimationEnd", "onDidMount", "onDidUnmount"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
// accessibility ok

var Dropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    directionVertical = props.directionVertical,
    directionHorizontal = props.directionHorizontal,
    isFitWindow = props.isFitWindow,
    isScaleAnimation = props.isScaleAnimation,
    opened = props.opened,
    portal = props.portal,
    style = props.style,
    onAnimationEnd = props.onAnimationEnd,
    onDidMount = props.onDidMount,
    onDidUnmount = props.onDidUnmount,
    attributes = _objectWithoutProperties(props, _excluded);
  var classElement = 'kui-dropdown';
  var _React$useState = React.useState(opened),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isMount = _React$useState2[0],
    setIsMount = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isTry = _React$useState4[0],
    setTry = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isOpen = _React$useState6[0],
    setOpen = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isScroll = _React$useState8[0],
    setScroll = _React$useState8[1];
  var itemRef = React.useRef(null);
  var onAnimationEndHadler = function onAnimationEndHadler(e) {
    if (!opened) {
      setIsMount(false);
    } else {
      // itemRef.current.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    }
    if (onAnimationEnd) onAnimationEnd(e);
  };
  React.useEffect(function () {
    if (opened) {
      setIsMount(true);
      setScroll(false);
      setTry(true);
      setTimeout(function () {
        var scroll = 0;
        if (itemRef.current && itemRef.current.scrollHeight && itemRef.current.offsetHeight) {
          scroll = itemRef.current.scrollHeight - itemRef.current.offsetHeight;
          setScroll(scroll > 0);
        }
        setTry(false);
        setOpen(true);
        if (onDidMount) onDidMount(scroll);
      }, 0);
    } else {
      setOpen(false);
    }
  }, [opened]);
  React.useEffect(function () {
    return function () {
      if (onDidUnmount) onDidUnmount();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "\n                ".concat(classElement, "\n                ").concat(directionVertical ? classElement + '--direction_' + directionVertical : '', "\n                ").concat(directionHorizontal ? classElement + '--direction_' + directionHorizontal : '', "\n                ").concat(isTry ? classElement + '--try' : '', "\n                ").concat(isOpen ? classElement + '--opened' : '', "\n                ").concat(portal ? classElement + '--portal' : '', "\n                ").concat(isFitWindow ? classElement + '--fit' : '', "\n                ").concat(isScaleAnimation ? classElement + '--scale' : '', "\n                ").concat(isScroll ? classElement + '--scroll' : '', "\n                ").concat(className, "\n            "),
    onAnimationEnd: onAnimationEndHadler,
    ref: ref
  }, attributes), isMount && /*#__PURE__*/React.createElement("div", {
    className: "kui-dropdown__item",
    ref: itemRef,
    "aria-live": 'assertive',
    role: 'alert',
    style: style
  }, children));
});
exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  directionVertical: 'auto',
  directionHorizontal: 'left',
  opened: false
};
Dropdown.displayName = 'Dropdown';